import { Edit, SimpleForm, TextInput } from "@/components/admin"
import { ReactElement } from "react"

const ExpertEdit = (): ReactElement => {
  return (
    <Edit mutationMode="optimistic">
      <SimpleForm>
        <TextInput source="username" label="Nom d'utilisateur" disabled />
        <TextInput source="class_id" label="Classe" disabled />
        <TextInput source="grade_id" label="Grade" disabled />

        <TextInput source="contract_id" label="ID de contrat" disabled />
      </SimpleForm>
    </Edit>
  )
}

export default ExpertEdit
